import React, { useRef, useState } from "react";
import { TbEditCircle } from "react-icons/tb";
import Skeleton from "react-loading-skeleton";
import { onImageHandler } from "../../../../../common/Image upload on bucket/UploadImageOnBucket";
import { useDispatch } from "react-redux";
import { CreateQuizcategorySlice } from "../../../../../redux/features/Quiz Management/QuizCategory";
import { toast } from "react-toastify";

const CreateCategory = ({ setState }) => {
  const [imageLoading, setImageLoading] = useState(false);
  const [iState, setUpdate] = useState({
    categoryName:"",
    categoryImage:""
  });
  const CloseRef = useRef();

  const dispatch = useDispatch();

  const handleUpload = async ({ e, setImageLoading, setUpdate }) => {
    setImageLoading(true);
    const data = await onImageHandler(e);
    setUpdate((prev) => ({ ...prev, [e.target.name]: data[1].location }));
    setImageLoading(false);
  };

  const submitCategory = () => {

    if(!iState?.categoryName) return toast.error("Please enter category name!")

    if(!iState?.categoryImage) return toast.error("Please select category image!")

    dispatch(CreateQuizcategorySlice(iState))?.then((res) => {
      if(res?.payload?.customStatus === 200){
        CloseRef.current.click();
      }
    });
  };

  return (
    <>
      <div
        id="AddQuizCategoryModal"
        className="modal fade"
        data-backdrop="static"
        style={{ display: "none" }}
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <div className="Category">
                <a
                  href="javascript:void(0);"
                  className="CloseModal"
                  data-dismiss="modal"
                  ref={CloseRef}
                  onClick={() => setState((prev) =>({...prev,add:!prev['add']}))}
                >
                  ×
                </a>
                <h3>Add QUIZ Category</h3>
                <div className="form-group">
                  <label>Category Title</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Quiz category name"
                    name="categoryName"
                    onChange={(e) =>
                      setUpdate((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="form-group">
                  <label>Upload Image </label>
                  <div className="UploadBox">
                    <div className="Upload" style={{ padding: "0" }}>
                      {imageLoading ? (
                        <Skeleton width={"100%"} height={"130px"} />
                      ) : iState?.categoryImage?.length > 0 ? (
                        <div
                          style={{
                            height: "100%",
                            width: "100%",
                            position: "relative",
                          }}
                        >
                          <img
                            src={iState?.categoryImage}
                            style={{ height: "100%", width: "100%" }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "10px",
                            }}
                          >
                            <input
                              type="file"
                              name="categoryImage"
                              accept=".jpg, .jpeg, .png"
                              onChange={(e) =>
                                handleUpload({ e, setImageLoading, setUpdate })
                              }
                              style={{
                                height: "100%",
                                width: "100%",
                                opacity: "0",
                              }}
                              className="file-input"
                            />
                            <TbEditCircle
                              style={{
                                fontSize: "20px",
                                backgroundColor: "gray",
                                color: "wheat",
                                cursor: "pointer",
                                borderRadius: "10px",
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <>
                          <div style={{ marginTop: "30px" }}>
                            <i className="fa fa-upload" /> <span>Upload </span>
                          </div>

                          <input
                            type="file"
                            name="categoryImage"
                            accept=".jpg, .jpeg, .png"
                            className="file-input"
                            onChange={(e) =>
                              handleUpload({ e, setImageLoading, setUpdate })
                            }
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <button className="Button" onClick={submitCategory}>Add Quiz Category</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateCategory;
